var SupportOrdersIteratorPaginatedCollection;

SupportOrdersIteratorPaginatedCollection = (function() {
  function SupportOrdersIteratorPaginatedCollection(ordersFilter) {
    this.ordersFilter = ordersFilter;
    this.size = 10;
    this.resetIterator();
    this.pagesRead = 0;
  }

  SupportOrdersIteratorPaginatedCollection.prototype.resetIterator = function() {
    this.currentOrdersOffset = 0;
    return this.state = "NOT_STARTED";
  };

  SupportOrdersIteratorPaginatedCollection.prototype.resetState = function() {
    return this.state = "NOT_STARTED";
  };

  SupportOrdersIteratorPaginatedCollection.prototype.hasNext = function() {
    if (this.isStateNotStarted()) {
      return true;
    } else if (this.isOrderCallQueued()) {
      return false;
    } else if (this.hasOrderCallFailed()) {
      return false;
    } else if (this.currentOrdersOffset < this.getNumberOfOrdersFetched()) {
      return true;
    } else if ((this.pagesRead * this.size) >= this.getTotalNumberOfGroupons()) {
      return false;
    }
    return true;
  };

  SupportOrdersIteratorPaginatedCollection.prototype.next = function(sucessCallback, errorCallback) {
    var _errorFilterCb, _sucessCb, _sucessFilterCb, options;
    if (this.hasNext()) {
      _sucessCb = (function(_this) {
        return function() {
          var offset;
          _this.state = "SUCCESS";
          offset = _this.currentOrdersOffset;
          _this.currentOrdersOffset = Math.min(_this.currentOrdersOffset + _this.size, _this.getNumberOfOrdersFetched());
          return sucessCallback(_this.ordersFilter.sortedOrders.slice(offset, offset + _this.size));
        };
      })(this);
      if (this.currentOrdersOffset < this.getNumberOfOrdersFetched()) {
        return _sucessCb();
      } else {
        options = {
          limit: 10,
          page: this.pagesRead
        };
        _errorFilterCb = (function(_this) {
          return function() {
            _this.state = "ERROR";
            return errorCallback();
          };
        })(this);
        _sucessFilterCb = (function(_this) {
          return function() {
            _this.pagesRead++;
            return _sucessCb();
          };
        })(this);
        this.state = "QUEUED";
        return this.ordersFilter.getOrders(options, _sucessFilterCb, _errorFilterCb);
      }
    }
  };

  SupportOrdersIteratorPaginatedCollection.prototype.isStateNotStarted = function() {
    return this.state === "NOT_STARTED";
  };

  SupportOrdersIteratorPaginatedCollection.prototype.isOrderCallQueued = function() {
    return this.state === "QUEUED";
  };

  SupportOrdersIteratorPaginatedCollection.prototype.hasOrderCallFailed = function() {
    return this.state === "ERROR";
  };

  SupportOrdersIteratorPaginatedCollection.prototype.getTotalNumberOfGroupons = function() {
    if (this.ordersFilter.pagination) {
      return this.ordersFilter.pagination.count;
    } else {
      return 0;
    }
  };

  SupportOrdersIteratorPaginatedCollection.prototype.getNumberOfOrdersFetched = function() {
    return this.ordersFilter.sortedOrders.length;
  };

  SupportOrdersIteratorPaginatedCollection.prototype.getNumberOfItemPerPage = function() {
    return this.size;
  };

  SupportOrdersIteratorPaginatedCollection.prototype.isOrdersInfoValid = function() {
    return !(this.isStateNotStarted() || (this.hasOrderCallFailed() && this.getNumberOfOrdersFetched() === 0));
  };

  return SupportOrdersIteratorPaginatedCollection;

})();

module.exports = SupportOrdersIteratorPaginatedCollection;

//# sourceMappingURL=data:application/json;base64,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
